"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Box = _interopRequireDefault(require("../../Containers/Box"));
var _HeaderButton = _interopRequireDefault(require("./common/HeaderButton"));
var _Popover = _interopRequireDefault(require("../../Tooltips/Popover"));
var _PrimaryButton = _interopRequireDefault(require("../../Buttons/PrimaryButton"));
var _Text = _interopRequireDefault(require("../../Typography/Text"));
var _useCurrentDate = _interopRequireDefault(require("../../_hooks/useCurrentDate"));
var _TimezoneContext = require("../../_contexts/TimezoneContext");
var _excluded = ["format", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /**Luxon date format */
  format: _propTypes["default"].string,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
var TimezoneSwitcher = function TimezoneSwitcher(_ref) {
  var _ref$format = _ref.format,
    format = _ref$format === void 0 ? "d MMM yyyy, HH:mm" : _ref$format,
    automationHook = _ref.automationHook,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useTimezone = (0, _TimezoneContext.useTimezone)(),
    timezone = _useTimezone.timezone,
    toggleTimezone = _useTimezone.toggleTimezone;
  var date = (0, _useCurrentDate["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    alignItems: "center",
    gap: "base"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    automationHook: (0, _automationHooks.getHook)(automationHook, "current-date")
  }, date.setZone(timezone).toFormat(format)), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    w: "260px",
    cardProps: {
      p: "base"
    },
    triggerW: "auto",
    align: "end",
    automationHook: automationHook,
    renderTrigger: function renderTrigger(_ref2) {
      var togglePopover = _ref2.togglePopover,
        isOpen = _ref2.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_HeaderButton["default"], _extends({
        triggerText: timezone === "UTC" ? "UTC" : "LT",
        isOpen: isOpen,
        onClick: togglePopover
      }, other));
    }
  }, function () {
    return /*#__PURE__*/_react["default"].createElement(_PrimaryButton["default"], {
      w: "100%",
      onClick: toggleTimezone,
      automationHook: (0, _automationHooks.getHook)(automationHook, "switcher")
    }, "Switch to ", timezone === "UTC" ? "Local" : "UTC", " time");
  }));
};
TimezoneSwitcher.propTypes = propTypes;
var _default = TimezoneSwitcher;
exports["default"] = _default;